export default {
  // 模块标题
  title: '表单管理',
  subtitle: '设计表单、配置流程、版本发布',
  
  // 导航
  nav: {
    overview: '概览',
    definitions: '表单定义',
    myInstances: '我的实例',
    review: '版本审核',
    templates: '表单模板',
    translations: '翻译管理',
    statistics: '统计分析',
    settings: '系统设置',
  },
  
  // 概览页
  overview: {
    title: '表单管理概览',
    description: '设计表单、配置审批流程、管理版本发布',
    stats: {
      totalForms: '表单总数',
      activeForms: '已发布',
      draftForms: '草稿',
      pendingReview: '待审核',
      templates: '表单模板',
    },
    quickActions: {
      createForm: '创建表单',
      createFormDesc: '从头开始创建新表单',
      useTemplate: '使用模板',
      useTemplateDesc: '从模板快速创建表单',
      manageForms: '管理表单',
      manageFormsDesc: '查看和编辑已有表单',
      startUsing: '开始',
      title: '快捷操作',
    },
    recentForms: '最近编辑',
    viewAll: '查看全部',
    tipTitle: '表单 + 流程一体化设计',
    tipDesc: '在设计器中同时完成表单字段设计和审批流程配置。发布后，用户可在审批中心发起申请。',
    pendingDesign: '待完成设计',
    goToReview: '去审核',
    formNameColumn: '表单名称',
    lastModifiedColumn: '最后修改',
  },
  
  // 表单定义
  definition: {
    title: '表单定义',
    description: '管理所有表单定义、版本和配置',
    createForm: '创建表单',
    searchPlaceholder: '搜索表单名称或 Key...',
    formInfo: '表单信息',
    key: 'Key',
    category: '分类',
    status: '状态',
    updatedAt: '更新时间',
    actions: '操作',
    noForms: '暂无表单',
    createFirst: '创建第一个表单',
    // 操作
    viewDetail: '查看详情',
    designForm: '设计表单',
    editInfo: '编辑信息',
    versionManage: '版本管理',
    clone: '复制',
    archive: '归档',
    delete: '删除',
    disable: '禁用',
    enable: '启用',
    // 状态
    statusLabels: {
      DRAFT: '草稿',
      PUBLISHED: '已发布',
      DISABLED: '已禁用',
      ARCHIVED: '已归档',
    },
    // 分类
    categories: {
      all: '全部分类',
      HR: '人力资源',
      FINANCE: '财务',
      IT: 'IT',
      ADMIN: '行政',
      OTHER: '其他',
    },
    // 确认操作
    confirmDelete: '确定要删除表单 "{name}" 吗？此操作不可恢复。',
    confirmArchive: '确定要归档表单 "{name}" 吗？归档后不可恢复。',
    onlyDraftCanDelete: '只有草稿状态的表单可以删除',
    allOrganizations: '所有组织',
    platformForms: '平台级表单',
    cloneFeatureComingSoon: '复制功能开发中',
  },

  // 翻译管理
  translationsPage: {
    emptyTitle: '暂无翻译',
    emptyDesc: '此版本暂无翻译',
    emptyAction: '添加第一个翻译',
    emptyKeysDesc: '暂无翻译内容，点击上方按钮添加',
  },
  
  // 创建表单
  create: {
    title: '创建表单',
    belongOrganization: '归属组织',
    platformLevelForm: '平台级通用表单（所有组织可用）',
    organizationHint: '选择组织后，表单仅对该组织成员可见；留空则为平台级通用表单',
    description: '定义表单基本信息，创建后可进入设计器配置字段和流程',
    blankCreate: '空白创建',
    blankCreateDesc: '从头开始，自由设计表单结构',
    useTemplate: '使用模板',
    useTemplateDesc: '从预置模板快速创建',
    basicInfo: '基本信息',
    formName: '表单名称',
    formNamePlaceholder: '例如：报销申请表',
    formKey: '表单 Key',
    formKeyPlaceholder: '例如：expense_claim',
    formKeyHint: '唯一标识符，仅支持小写字母、数字和下划线，以字母开头',
    formDescription: '表单描述',
    formDescriptionPlaceholder: '描述此表单的用途和使用场景...',
    approvalConfig: '审批配置',
    requiresApproval: '需要审批流程',
    requiresApprovalHint: '开启后，用户提交表单将进入审批流程',
    approvalTip: '创建表单后，您可以在设计器的「流程设计」标签中配置审批节点和流程逻辑。',
    createAndDesign: '创建并进入设计器',
    creating: '创建中...',
    keyFormatError: '表单 Key 只能包含小写字母、数字和下划线，且必须以字母开头',
    advancedOptions: '高级选项',
    autoGeneratedKey: '表单标识',
    keyAutoGenerated: '系统将自动生成唯一标识',
    keyCustomHint: '留空则自动生成，自定义需符合格式：小写字母开头，仅含字母、数字、下划线',
  },
  
  // 版本审核
  review: {
    title: '版本审核',
    description: '审核设计者提交的表单版本，审核通过后将自动发布',
    pending: '待审核',
    submittedBy: '提交人',
    submittedAt: '提交时间',
    submissionNote: '提交说明',
    preview: '预览',
    approve: '通过',
    reject: '驳回',
    approveTitle: '审核通过',
    rejectTitle: '驳回版本',
    approveDesc: '确认通过后，版本将自动发布并设为当前默认版本。',
    rejectDesc: '请填写驳回原因，帮助设计者改进表单设计。',
    reviewComment: '审核意见',
    rejectReason: '驳回原因',
    rejectReasonPlaceholder: '请说明驳回的原因，例如：字段命名不规范、缺少必要验证等...',
    confirmApprove: '确认通过',
    confirmReject: '确认驳回',
    noItems: '暂无待审核的版本',
    noItemsDesc: '设计者提交的版本将会出现在这里',
    snapshotId: '快照 ID',
    formVersionId: '表单版本 ID',
    processVersionId: '流程版本 ID',
    formSchema: '表单结构 (Schema)',
    processModel: '流程模型',
    previewUser: '预览用户',
    rdDept: '研发部',
    productDept: '产品部',
    previewDataLogged: '预览数据已打印到控制台',
    approvedAndPublished: '审核通过，已发布！',
    statusRejected: '已驳回',
    showOnlyMine: '仅显示我提交的',
    filteredCount: '筛选后: {count} 条',
    refresh: '刷新',
    noMyPending: '暂无我提交的待审核记录',
    mySubmittedWillShowHere: '您提交的表单设计审核将显示在这里',
    showAll: '查看全部',
    mine: '我的',
    previewFormAndProcess: '预览表单设计效果和审批流程',
    formPreview: '表单预览',
    submitPreview: '提交预览',
    noFormSchema: '暂无表单结构',
    approvalProcessPreview: '审批流程预览',
    processAccordingToWorkflow: '提交表单后将按上述流程进行审批',
    noApprovalRequired: '此表单无需审批流程',
    technicalDetails: '技术详情',
  },
  
  // 发布（激活）
  publish: {
    title: '激活版本',
    description: '激活后，此版本将成为当前默认版本，用户在审批中心将使用此版本。',
    approved: '版本已审核通过，是否立即激活为当前版本？',
    releaseNote: '版本说明',
    releaseNotePlaceholder: '记录本次版本的主要变更...',
    publishNow: '立即激活',
    publishLater: '稍后激活',
    publishing: '激活中...',
    publishSuccess: '激活成功！新版本已生效',
  },
  
  // 快照/版本状态（简化流程：审核通过=发布，无单独的 APPROVED 状态）
  snapshotStatus: {
    DRAFT: '草稿',
    PENDING: '待审核',
    PENDING_REVIEW: '待审核',
    PUBLISHED: '已发布',
    ACTIVE: '已发布',
    REJECTED: '已驳回',
    DEPRECATED: '已废弃',
    ARCHIVED: '已归档',
    SUSPENDED: '已暂停',
  },
  
  // 版本
  version: {
    title: '版本管理',
    list: '版本列表',
    create: '创建新版本',
    compare: '版本对比',
    // 版本状态（简化流程：审核通过=发布）
    status: {
      DRAFT: '草稿',
      PENDING_REVIEW: '待审核',
      PUBLISHED: '已发布',
      REJECTED: '已驳回',
      DEPRECATED: '已废弃',
    },
    isDefault: '默认版本',
    setDefault: '设为默认',
    publish: '发布版本',
    deprecate: '废弃版本',
    submitReview: '提交审核',
    versionName: '版本名称',
    releaseNote: '发布说明',
  },
  
  // 我的提交
  submissions: {
    title: '我的提交',
    description: '查看我提交的版本审核记录和状态',
    status: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已驳回',
      all: '全部',
    },
    resubmit: '重新提交',
    edit: '编辑',
    viewHistory: '历史',
    reviewHistory: '审核历史',
    rejectedReason: '驳回原因',
    noRecords: '暂无提交记录',
    noRecordsDesc: '设计表单后提交审核，记录将显示在这里',
    goDesign: '去设计表单',
    submittedAt: '提交于',
    reviewedAt: '审核于',
  },
  
  // 表单实例
  instance: {
    title: '我的表单实例',
    description: '查看和管理我提交的所有表单实例',
    businessKey: '业务单号',
    region: '所属区域',
    status: {
      DRAFT: '草稿',
      SUBMITTED: '已提交',
      PENDING_APPROVAL: '审批中',
      APPROVED: '已批准',
      REJECTED: '已驳回',
      WITHDRAWN: '已撤回',
      CANCELLED: '已取消',
    },
    actions: {
      view: '查看详情',
      edit: '编辑',
      submit: '提交',
      withdraw: '撤回',
      resubmit: '重新提交',
      saveDraft: '保存草稿',
      cancel: '取消',
      delete: '删除',
    },
    noInstances: '暂无表单实例',
    submittedAt: '提交时间',
    createdAt: '创建时间',
    approvalStatus: '审批状态',
    withdrawConfirm: '确定要撤回此申请吗？',
    withdrawReason: '撤回原因',
    withdrawReasonPlaceholder: '请输入撤回原因（可选）',
    withdrawSuccess: '撤回成功',
    withdrawFailed: '撤回失败',
    notFound: '表单实例不存在',
    defaultTitle: '表单实例',
    statusMessages: {
      pendingApproval: '此表单正在审批中，您可以撤回此申请。',
      approved: '此表单已审批通过。',
      cancelled: '此表单已被取消。',
      cannotEdit: '此表单当前状态无法编辑。',
    },
    approvalInfo: '审批信息',
    approvalStatusLabel: '审批状态',
    processing: '处理中',
    startTime: '开始时间',
    viewApprovalDetails: '查看审批详情',
    instanceInfo: '实例信息',
    instanceId: '实例 ID',
    formVersion: '表单版本',
    lastUpdated: '最后更新',
    createdBy: '创建人',
    
    // 表单提交页面
    loadingForm: '加载表单中...',
    formNotFound: '表单不存在',
    formNotFoundDesc: '未找到该表单，可能已被删除或您没有权限访问。',
    backToApproval: '返回审批中心',
    back: '返回',
    formIncomplete: '表单设计不完整，无法填写',
    draftUpdated: '草稿已更新',
    draftSaved: '草稿已保存',
    saveFailed: '保存失败',
    submitSuccess: '表单提交成功，审批流程已启动！',
    submitFailed: '提交失败',
    submitting: '提交中...',
    saveDraft: '保存草稿',
    saving: '保存中...',
    pleaseSelectDepartment: '请选择提交部门',
    createDraftFailed: '创建草稿失败：返回数据无效',
    createInstanceFailed: '创建实例失败：返回数据无效',
    unknownError: '未知错误',
    loadFormFailed: '加载表单失败',
    
    // 审批流程预览
    approvalProcessPreview: '审批流程预览',
    approvalProcess: '审批流程',
    loadingProcessPreview: '加载流程预览...',
    processPreviewHint: '💡 提交后将按上述流程进行审批',
    processPreviewIncomplete: '请填写必填信息以查看完整的审批流程。',
    currentUser: '当前用户',
  },
  
  // 模板
  template: {
    title: '表单模板',
    description: '使用预定义模板快速创建表单',
    create: '创建模板',
    public: '公开模板',
    builtin: '内置模板',
    useTemplate: '使用此模板',
    createFromTemplate: '从模板创建',
    noTemplates: '暂无模板',
    categories: {
      all: '全部分类',
      HR: '人力资源',
      FINANCE: '财务',
      IT: 'IT',
      ADMIN: '行政',
      OTHER: '其他',
    },
  },
  
  // 模板页面（/forms/templates）
  templates: {
    title: '表单模板',
    searchPlaceholder: '搜索模板...',
    create: '创建模板',
    preview: '预览',
    use: '使用',
    builtin: '内置',
    public: '公开',
    noTemplates: '暂无模板',
    noTemplatesDesc: '创建您的第一个模板',
  },
  
  // 翻译
  translation: {
    title: '翻译管理',
    description: '管理表单版本的多语言翻译',
    selectForm: '选择表单',
    selectVersion: '选择版本',
    defaultLocale: '默认语言',
    supportedLocales: '支持语言',
    addTranslation: '添加翻译',
    editTranslation: '编辑翻译',
    deleteTranslation: '删除翻译',
    batchImport: '批量导入',
    completeness: '完整度',
    coverage: '覆盖率',
    complete: '翻译完整',
    incomplete: '翻译不完整',
    missingKeys: '缺少',
    noTranslations: '此版本暂无翻译',
    addFirst: '添加第一个翻译',
    translationContent: '翻译内容',
    addKey: '添加键',
    noContent: '暂无翻译内容，点击上方按钮添加',
    languages: {
      'zh-CN': '简体中文',
      'zh-TW': '繁体中文',
      'en-US': 'English',
      'ja-JP': '日本語',
      'ko-KR': '한국어',
    },
    import: {
      title: '批量导入翻译',
      description: '以 JSON 格式导入多语言翻译数据',
      formatExample: 'JSON 格式示例',
      placeholder: '粘贴 JSON 格式的翻译数据...',
      button: '导入',
      success: '导入成功',
    },
  },
  
  // 设计器
  designer: {
    title: '表单设计器',
    loading: {
      processDesigner: '加载流程设计器...',
    },
    tabs: {
      form: '表单设计',
      process: '流程设计',
      preview: '预览',
    },
    fieldPalette: '字段控件',
    designCanvas: '设计画布',
    dragToAdd: '拖拽添加字段',
    dropHere: '拖放字段到这里',
    noFieldSelected: '未选中字段',
    selectFieldToEdit: '选择一个字段来编辑其属性',
    fieldTypes: {
      text: '文本输入',
      textarea: '多行文本',
      number: '数字输入',
      money: '金额',
      email: '邮箱',
      phone: '电话',
      url: '链接',
      select: '下拉选择',
      multiSelect: '多选',
      radio: '单选按钮',
      checkbox: '复选框',
      member: '成员',
      department: '部门',
      date: '日期选择',
      dateRange: '日期区间',
      time: '时间选择',
      datetime: '日期时间',
      file: '文件上传',
      image: '图片上传',
      richText: '富文本',
      signature: '签名',
      seal: '电子签章',
      detail: '子表单',
      container: '布局容器',
      group: '分组',
      serialNumber: '流水号',
      relatedForm: '关联表单',
      relatedQuery: '关联查询',
      address: '地址',
      region: '国家/地区',
      location: '位置选择',
      cascade: '级联选择',
      rating: '评分',
      switch: '开关',
      slider: '滑块',
      color: '颜色选择',
      hidden: '隐藏字段',
      imageText: '图文展示',
      wordTemplate: 'Word 模板',
      currency: '货币',
    },
    fieldGroups: {
      basic: '基础字段',
      advanced: '高级字段',
      layout: '布局组件',
    },
    defaults: {
      input: '请输入',
      select: '请选择',
      number: '请输入数字',
      amount: '请输入金额',
      member: '选择成员',
      department: '选择部门',
      date: '选择日期',
      location: '点击获取定位',
      related: '选择关联数据',
      address: '请输入地址',
      optionLabel: '选项{index}',
      groupTitle: '分组标题',
    },
    palette: {
      searchPlaceholder: '搜索控件',
      noMatch: '没有匹配的控件',
      categories: {
        basic: '基础',
        advanced: '高级',
      },
    },
    properties: {
      basic: '基本属性',
      fieldKey: '字段标识',
      fieldKeyPlaceholder: '唯一标识，如 firstName',
      label: '标签',
      labelPlaceholder: '显示的标签文本',
      placeholder: '占位符',
      placeholderPlaceholder: '输入提示文本',
      defaultValue: '默认值',
      helpText: '帮助文本',
      validation: '验证规则',
      required: '必填',
      minLength: '最小长度',
      maxLength: '最大长度',
      pattern: '正则表达式',
      style: '样式',
      width: '宽度',
      options: '选项',
      addOption: '添加选项',
      optionLabel: '选项标签',
      optionValue: '选项值',
    },
    status: {
      draft: '草稿',
      pendingReview: '待审核',
      published: '已发布',
      rejected: '已驳回',
      deprecated: '已废弃',
    },
    actions: {
      save: '保存',
      saving: '保存中...',
      saveAsDraft: '保存草稿',
      preview: '预览',
      submitReview: '提交审核',
      confirmSubmit: '确认提交',
      submitting: '提交中...',
      submitPreview: '提交预览',
      publish: '发布',
      createNewVersion: '创建新版本',
      creating: '创建中...',
      undo: '撤销',
      redo: '重做',
      clear: '清空画布',
    },
    process: {
      enableApproval: '启用审批流程',
      enableApprovalHint: '表单提交后将自动启动审批流程',
      statusEnabled: '已启用 - 表单提交后需要审批',
      statusDisabled: '已关闭 - 表单提交后直接完成',
      active: '审批流程已激活',
      helpEnabled: '请在下方配置审批节点和流程',
      helpDisabled: '开启后可配置审批流程',
      disabledHint: '关闭后表单提交将直接完成，不经过审批',
      noProcess: '审批流程已关闭',
      noProcessDesc: '当前表单提交后将直接完成处理。如需添加审批流程，请先开启上方的"启用审批流程"开关。',
      enableButton: '启用审批流程',
    },
    noFields: '暂无字段，请先在表单设计模式下添加字段',
    previewTitle: '表单预览',
    processPreviewTitle: '审批流程预览',
    processPreviewHint: '提交表单后将按上述流程进行审批',
    noProcessWarning: '已启用审批流程，但尚未配置流程节点',
    configProcess: '去配置流程',
    canvas: {
      ratingUnit: '分',
      fileUpload: {
        title: '点击或拖拽文件上传',
        hint: '支持常见文件格式',
      },
      imageUpload: {
        title: '点击或拖拽图片上传',
        hint: '支持 JPG、PNG、GIF',
      },
      memberPlaceholder: '选择成员',
      departmentPlaceholder: '选择部门',
      locationPlaceholder: '点击获取定位',
      serialNumberPlaceholder: '自动生成',
      relatedPlaceholder: '选择关联数据',
      addressRegionPlaceholder: '选择省/市/区',
      addressDetailPlaceholder: '详细地址',
      regionPlaceholder: '选择国家/地区',
      cascadePlaceholder: '请选择',
      signature: {
        title: '点击此处签名',
        hint: '签名将保存为图片',
      },
      seal: {
        title: '选择电子签章',
        hint: '支持多种签章',
      },
      richTextPlaceholder: '请输入富文本内容...',
      wordTemplate: {
        title: 'Word 模板',
        action: '点击配置模板',
      },
      currencyPlaceholder: '请输入金额',
      unknownPlaceholder: '--',
      empty: {
        dropTitle: '松开添加组件',
        dropSubtitle: '将组件放入表单',
        idleTitle: '从左侧拖拽组件到这里',
        idleSubtitle: '开始设计你的表单',
      },
      toolbar: {
        undo: '撤销 (Ctrl+Z)',
        redo: '重做 (Ctrl+Y)',
        history: '历史记录',
        search: '搜索',
        shortcuts: '快捷键',
      },
      actions: {
        duplicate: '复制',
        delete: '删除',
      },
      datePlaceholder: '选择日期',
      timePlaceholder: '选择时间',
      dateRangeStartPlaceholder: '开始日期',
      dateRangeEndPlaceholder: '结束日期',
      dateRangeTo: '至',
      multiSelectPlaceholder: '请选择（多选）',
    },
    detail: {
      actions: {
        tableActions: '操作',
        delete: '删除',
        addItem: '添加行',
        batchImport: '批量导入',
      },
      dialog: {
        editColumnTitle: '编辑列属性',
      },
      dropzone: {
        invalidTitle: '不支持的控件',
        invalidDesc: '子表单不支持嵌套布局容器或子表单',
        validTitle: '松开添加列',
        validDesc: '将创建新的子表单列',
        idleTitle: '从左侧拖拽控件到这里',
        idleDesc: '为子表单添加列',
      },
      column: {
        edit: '编辑',
        delete: '删除',
      },
      placeholders: {
        input: '请输入',
        textarea: '请输入',
        number: '请输入数字',
        select: '请选择',
        date: '选择日期',
        member: '选择成员',
        department: '选择部门',
        upload: '点击上传',
        default: '--',
      },
      editor: {
        columnTitle: '列标题',
        fieldKey: '字段标识',
        optionsPerLine: '选项（每行一个）',
        optionsPlaceholder: '选项1\n选项2\n选项3',
        required: '必填',
        done: '完成',
      },
    },
    propertyPanel: {
      emptyHint: '选择画布中的节点进行编辑',
      detailColumnPrefix: '明细列 · {label}',
      tabs: {
        formSettings: '表单设置',
        pageProperties: '页面属性',
      },
      formSettings: {
        placeholder: '表单级设置',
        developing: '(开发中)',
      },
      labels: {
        componentId: '组件标识',
        title: '标题',
        placeholder: '占位符',
        description: '说明',
        defaultValue: '默认值',
        defaultAmount: '默认金额',
        status: '状态',
        required: '必填',
        optionsSettings: '选项设置',
        minLength: '最小长度',
        maxLength: '最大长度',
        minValue: '最小值',
        maxValue: '最大值',
        precision: '小数位数',
        prefix: '前缀',
        suffix: '后缀',
        defaultCurrency: '默认货币',
        allowCurrencySelect: '货币选择器',
        allowedCurrencies: '可选货币',
        minRows: '最少行数',
        maxRows: '最多行数',
        layout: '布局',
        columnRatio: '列比例',
        columnGap: '列间距',
        rowGap: '行间距',
      },
      placeholders: {
        input: '请输入',
        description: '字段说明',
        number: '请输入数字',
        select: '请选择',
        defaultValue: '填写默认值',
        amount: '填写金额',
        option: '选项',
        noLimit: '不限',
        currencyPrecision: '2',
        prefixExample: '例如 ¥',
        suffixExample: '例如 CNY',
        columnRatioExample: '例如 1:2:1',
        minRows: '0',
      },
      statusOptions: {
        normal: '普通',
        disabled: '禁用',
        readonly: '只读',
        hidden: '隐藏',
      },
      yesNo: {
        yes: '是',
        no: '否',
      },
      options: {
        listTitle: '选项列表',
        add: '添加',
        emptyHint: '请先添加选项',
      },
      select: {
        noneLabel: '无',
      },
      currency: {
        cny: 'CNY（人民币）',
        usd: 'USD（美元）',
        eur: 'EUR（欧元）',
        jpy: 'JPY（日元）',
        gbp: 'GBP（英镑）',
        hkd: 'HKD（港币）',
        cnyShort: 'CNY',
        usdShort: 'USD',
        eurShort: 'EUR',
        jpyShort: 'JPY',
        gbpShort: 'GBP',
        hkdShort: 'HKD',
      },
      layoutPresets: {
        col1: '1列',
        col2Equal: '1:1',
        col2LeftWide: '2:1',
        col2RightWide: '1:2',
        col3Equal: '1:1:1',
        col3LeftWide: '2:1:1',
        col3MiddleWide: '1:2:1',
        col4Equal: '1:1:1:1',
      },
      gaps: {
        none: '无（0px）',
        small: '小（8px）',
        medium: '中（16px）',
        large: '大（24px）',
      },
      detailHint: '💡 点击画布子表单中的“添加列”按钮来配置列',
      containerHint: '💡 从左侧拖拽组件到每一列',
    },
    group: {
      placeholder: '分组',
      developing: '分组设计器开发中...',
    },
    container: {
      placeholder: '布局容器',
      columns: '{count}列',
      column: '第{index}列',
      developing: '布局容器设计器开发中...',
    },
    preview: {
      submitterName: '预览用户',
      departments: {
        dev: '研发部',
        product: '产品部',
      },
    },
    permission: {
      title: '无权访问表单设计器',
      description: '您没有表单设计权限，无法访问此页面。需要以下权限之一：{permissions}',
    },
    dialog: {
      submitTitle: '提交版本审核',
      submitDescription: '提交后管理员将审核此版本，审核通过后方可发布使用。',
      submitNoteLabel: '提交说明（可选）',
      submitNotePlaceholder: '描述本次修改的内容...',
      createVersionDescription: '当前版本已发布，需要创建新版本才能继续编辑。新版本将基于当前设计内容创建。',
      createVersionHint: '将基于 v{current} 创建新版本 v{next}',
    },
    messages: {
      loadFailed: '加载失败: {message}',
      saveSuccess: '保存成功',
      saveFailed: '保存失败: {message}',
      submitReviewSuccess: '已提交审核，请等待管理员审核',
      submitReviewFailed: '提交审核失败: {message}',
      newVersionCreated: '新版本 v{version} 已创建',
      createVersionFailed: '创建版本失败: {message}',
      previewSubmit: '表单数据已打印到控制台',
    },
  },

  fieldRenderer: {
    address: {
      provincePlaceholder: '省/州',
      cityPlaceholder: '市',
      districtPlaceholder: '区/县',
      detailPlaceholder: '详细地址',
    },
    region: {
      placeholder: '请选择国家/地区',
    },
    serialNumber: {
      placeholder: '提交后自动生成',
    },
    signature: {
      clear: '清除',
      signed: '已签名',
      hint: '在上方签名区域绘制',
    },
    richtext: {
      loading: '加载中…',
      bold: '加粗',
      italic: '斜体',
      strike: '删除线',
      bulletList: '无序列表',
      orderedList: '有序列表',
      blockquote: '引用',
      undo: '撤销',
      redo: '重做',
      placeholder: '请输入',
    },
    cascade: {
      placeholder: '请选择',
      empty: '未配置选项',
    },
  },

  // 通用
  common: {
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    search: '搜索',
    filter: '筛选',
    status: '状态',
    optional: '可选',
    allStatus: '全部状态',
    allCategories: '全部分类',
    actions: '操作',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '关闭',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    yes: '是',
    no: '否',
    page: '第 {current} / {total} 页',
    totalItems: '共 {total} 条',
    previousPage: '上一页',
    nextPage: '下一页',
    noData: '暂无数据',
    processing: '处理中...',
    confirmDelete: '确定要删除吗？此操作不可恢复。',
  },
  
  // 统计分析
  statistics: {
    title: '统计分析',
    subtitle: '表单使用情况和数据分析',
    description: '查看表单提交、审批和使用情况的统计数据',
    timeRange: {
      last7Days: '最近 7 天',
      last30Days: '最近 30 天',
      last90Days: '最近 90 天',
      last1Year: '最近 1 年',
    },
    cards: {
      totalForms: '总表单数',
      totalSubmissions: '总提交数',
      approvalRate: '审批通过率',
      avgProcessingTime: '平均处理时间',
      activeForms: '已发布',
      activeUsers: '活跃用户',
      processingCycle: '审批周期',
      stable: '保持稳定',
    },
    topForms: {
      title: '热门表单排行',
      submissions: '次提交',
      approvalRate: '通过率',
      avgTime: '平均时长',
    },
    charts: {
      submissionTrend: '提交趋势',
      categoryDistribution: '分类分布',
      submissions: '提交数',
      approvals: '通过数',
      rejections: '驳回数',
    },
    loading: '加载中...',
    noData: '暂无数据',
  },
  
  // 消息
  messages: {
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    loadFailed: '加载失败',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    formCreated: '表单创建成功',
    formArchived: '表单已归档',
    formPublished: '表单已发布',
    draftCannotToggle: '草稿状态无法直接切换',
    versionPublished: '版本已发布',
    versionDeprecated: '版本已废弃',
    reviewSubmitted: '已提交审核',
    reviewApproved: '版本已审核通过',
    reviewRejected: '版本已驳回',
    publishSuccess: '发布成功！表单已上线',
    translationSaved: '翻译保存成功',
    translationDeleted: '翻译已删除',
    importSuccess: '导入成功',
    fillRequired: '请填写所有必填字段',
  },
  
  // 区域
  region: {
    CN: '中国',
    US: '美国',
    ME: '中东',
    all: '全部区域',
  },
};
